import { render, staticRenderFns } from "./UnitGroup.vue?vue&type=template&id=3190bd46&"
import script from "./UnitGroup.vue?vue&type=script&lang=js&"
export * from "./UnitGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports